import { CatchAPIService, MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class SettingService {
  DoGetSettingTransactionDueDate() {
    const input: any = {
      merchantId: MerchantId(),
    };
    return service.peakExportAPI
      .post("/api/Merchant/GetSettingTransactionDueDate", input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetMerchantSettingTaxInvoice() {
    const input: any = {
      data: {},
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantSettingTaxInvoice", input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetSettingTransactionRemark(isUseMainDatabase: boolean) {
    const input = {
      merchantId: MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return service.peakExportAPI
      .post("/api/Merchant/GetSettingTransactionRemark", input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
}

export default new SettingService();
